import { Box, Button } from "@mui/material";
import { H3, H5, H2 } from "../components/Typography";
import { FC } from "react";
// root component interface
interface KYCProps {
  onPress?: any;
  title?: string;
  subtitle?: string;
  buttonTitle?: string;
}

const KYCCard: FC<KYCProps> = ({ title, onPress, buttonTitle, subtitle }) => {
  return (
    <Box
      sx={{
        marginRight: 2,
        display: {
          md: "flex",
          xs: subtitle === "KYC completed sucessfully" ? "none" : "flex",
        },
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        paddingTop: 2,
        paddingBottom: 2,
        backgroundColor: "#fff",
        flexDirection: "column",
        borderRadius: 3,
      }}
    >
      <Box
        component="img"
        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/kyc.svg"
        sx={sxStyleImage}
      />
      <H3 sx={headingText}>{title}</H3>
      {subtitle && (
        <H2 fontSize={16} sx={headingText1}>
          {subtitle}
        </H2>
      )}
      <H5 color="text.disabled"></H5>
      {buttonTitle && (
        <Button
          onClick={onPress}
          type="submit"
          size="medium"
          sx={{
            background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            borderRadius: 2,
            padding: 0.36,
            paddingLeft: 2,
            color: "#fff",
            paddingRight: 2,
            marginTop: 0.5,
            fontSize: 10,
            textTransform: "none",
          }}
        >
          {buttonTitle}
        </Button>
      )}
    </Box>
  );
};

export default KYCCard;
const headingText = {
  mt: 0.8,
  mb: 0.8,
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const headingText1 = {
  p: 2,
  textAlign: "center",
  fontFamily: "'Poppins', sans-serif",
};

const sxStyleImage = {
  height: {
    xs: "20%",
    sm: "20%",
    md: "20%",
  },
  width: {
    xs: "20%",
    sm: "20%",
    md: "15%",
  },
};
